<template>
    <div id="modal-calculator-add-to-cart" aria-hidden="true"
         class="modal modal-calculator calculator-scoped-add-to-cart">
        <div tabindex="-1" class="modal-wrapp">
            <div role="dialog" aria-modal="true" class="modal-body">
                <a href="#" class="modal-close-btn" aria-label="Закрыть" data-modal-close>
                    <svg width="12" height="12">
                        <use xlink:href="#icon-close"/>
                    </svg>
                </a>
                <div class="calculator-add-to-cart-img">
                    <img :src="`${templateFolder}/img/calculator-add-to-cart-img.svg`" alt="">
                </div>
                <div class="calculator-add-to-cart-title h2">Товар добавлен в&nbsp;корзину</div>
                <ul class="calculator-add-to-cart-btns">
                    <li>
                        <a href="#" class="calculator-new-order-btn btn btn-full-width btn-border"
                           @click.prevent="goToCalculatorStep(1)">
                            Добавить еще
                        </a>
                    </li>
                    <li>
                        <a href="#" class="calculator-go-to-cart-btn btn btn-full-width"
                           @click.prevent="goToCalculatorStep(4)">
                            Перейти в корзину
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalCalculatorAddToCart",
    props: {
        templateFolder: {
            type: String,
            default: '',
            required: true,
        },
    },
    methods: {
        goToCalculatorStep(step) {
            Modal.openModal('modal-calculator');

            this.emitter.emit('calculator-go-to-step', step);
        }
    }
}
</script>

<style scoped>

</style>